import Vue from "vue"

export function notifyLeadUpdate(response) {
  const header = response && response.headers && response.headers["x-roody-lead-notice"]
  if (!header) return response
  let message
  try {
    message = decodeURIComponent(header)
  } catch (_) {
    return response
  }
  // Toast messages support HTML; category names must always remain plain text.
  const entities = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }
  message = message.replace(/[&<>"']/g, (character) => entities[character])
  if (Vue.prototype.$toast) Vue.prototype.$toast.info(message, { duration: 6500 })
  return response
}
